import * as React from "react";
import { TextInput, NumberInput, required } from "react-admin";
import Transformer from "../../common/Transformer";
import { FaqEditComponent } from "./";
import { TinyMCEContentInput } from "src/components/input";
import { Edit, SimpleForm } from "src/enterprise/ra-rbac";
import { Grid } from "@mui/material";

export const FaqEdit = () => {
  const transform = (data) => {
    Transformer(data, {
      remove: ["id", "createdAt", "updatedAt"],
      update: {},
    });

    return data;
  };

  return (
    <Edit
      component={FaqEditComponent}
      mutationMode="pessimistic"
      transform={transform}
    >
      <SimpleForm>
        <Grid container rowSpacing={1} columnSpacing={2}>
          <Grid item lg={8} sm={12}>
            <TextInput disabled source="id" />
          </Grid>
          <Grid item lg={8} sm={12}>
            <TextInput source="question" validate={required()} />
          </Grid>
          <Grid item lg={8} sm={12}>
            <NumberInput source="sort_order" />
          </Grid>
          <Grid item sm={12}>
            <TinyMCEContentInput source="answer" required base64></TinyMCEContentInput>
          </Grid>
        </Grid>
      </SimpleForm>
    </Edit>
  );
};
